import { render, staticRenderFns } from "./DisabledAccount.vue?vue&type=template&id=766046a4&scoped=true&"
import script from "./DisabledAccount.vue?vue&type=script&lang=js&"
export * from "./DisabledAccount.vue?vue&type=script&lang=js&"
import style0 from "./DisabledAccount.vue?vue&type=style&index=0&id=766046a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766046a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
